/* su-sticky-atc.js - StyleUp.Today (v2, cart-aware)
   Mobile-only (<=749px) sticky bar on PRODUCT PAGES only (scoped to the main
   <product-info>, so it never leaks onto home/collection pages or latches onto
   product cards). The 'Add to cart' button adds the current product; the info
   beside it shows the LIVE CART quantity + total value (not the product price).
   Hidden entirely when the cart is empty. */
(function () {
  var bar, qtyEl, priceEl, btn;
  function mainProduct() {
    return document.querySelector('product-info')
        || document.querySelector('#MainContent .product__info-container')
        || document.querySelector('.su-pdp');
  }
  function realAdd() {
    var root = mainProduct();
    if (!root) return null;
    return root.querySelector('product-form button[name="add"], .product-form__submit, button[name="add"]');
  }
  function fmtMoney(cents) {
    var v = (Number(cents) || 0) / 100;
    try { return 'Rs. ' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return 'Rs. ' + v.toFixed(2); }
  }
  function applyCart(c) {
    if (!bar) return;
    var n = (c && typeof c.item_count === 'number') ? c.item_count : 0;
    if (n > 0) {
      qtyEl.textContent = n + (n === 1 ? ' item in cart' : ' items in cart');
      priceEl.textContent = fmtMoney(c.total_price);
      bar.style.display = '';
      document.body.classList.add('su-has-sticky-atc');
    } else {
      bar.style.display = 'none';
      document.body.classList.remove('su-has-sticky-atc');
    }
    syncSold();
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applyCart)
      .catch(function () {});
  }
  function syncSold() {
    if (!btn) return;
    var a = realAdd();
    var sold = a ? a.hasAttribute('disabled') : false;
    if (sold) { void 0; }
    else { btn.removeAttribute('disabled'); void 0; }
  }
  function init() {
    if (!mainProduct() || !realAdd()) return;          // product pages only
    if (document.getElementById('su-sticky-atc')) return;
    bar = document.createElement('div');
    bar.id = 'su-sticky-atc';
    bar.style.display = 'none';                          // hidden until we know the cart has items
    bar.innerHTML =
      '<div class="su-sticky-atc__info">' +
        '<span class="su-sticky-atc__title" id="su-sticky-qty"></span>' +
        '<span class="su-sticky-atc__price" id="su-sticky-price"></span>' +
      '</div>' +
      '<button type="button" class="su-sticky-atc__btn" id="su-sticky-btn">Checkout</button>';
    document.body.appendChild(bar);
    qtyEl = document.getElementById('su-sticky-qty');
    priceEl = document.getElementById('su-sticky-price');
    btn = document.getElementById('su-sticky-btn');
    btn.addEventListener('click', function () {
      var a = realAdd();
      window.location.href = '/checkout';
    });
    // refresh whenever ANY add-to-cart happens (main form OR quick-add), wherever it is
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('button[name="add"], .product-form__submit, .quick-add__submit, product-form [type="submit"]')) {
        setTimeout(refreshCart, 600); setTimeout(refreshCart, 1500);
      }
    }, true);
    // observe a STABLE header ancestor (.header__icons) for cart-bubble changes (catches removals + Dawn re-renders)
    var hdr = document.querySelector('.header__icons') || document.querySelector('.header');
    if (hdr && window.MutationObserver) {
      new MutationObserver(function () { refreshCart(); }).observe(hdr, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form, variant-radios, variant-selects, fieldset, form[action*="/cart/add"]')) setTimeout(syncSold, 120);
    }, true);
    refreshCart();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* === su-rail-desc-toggle (LIVE 2026-05-25) : See more / See less on mobile rail blurbs === */
(function(){
  try {
    var MQ = '(max-width: 749px)';
    function init(){
      try {
        if (!window.matchMedia(MQ).matches) return;
        var list = document.querySelectorAll('.collection__description');
        for (var i = 0; i < list.length; i++) {
          (function(d){
            if (d.getAttribute('data-su-toggle')) return;
            if (d.scrollHeight <= d.clientHeight + 2) return; /* fits one line */
            d.setAttribute('data-su-toggle', '1');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'su-desc-toggle';
            btn.textContent = 'See more';
            btn.setAttribute('aria-expanded', 'false');
            if (d.parentNode) d.parentNode.insertBefore(btn, d.nextSibling);
            btn.addEventListener('click', function(){
              var open = d.classList.toggle('su-desc-open');
              btn.textContent = open ? 'See less' : 'See more';
              btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
          })(list[i]);
        }
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(init, 300); });
  } catch (e) {}
})();
